import * as BaseSwitch from "@radix-ui/react-switch";
import { useId } from "react";
import * as switchStyles from "./Switch.css";

export interface SwitchProps {
  /**
   * If true, the component is checked.
   */
  checked: boolean;
  /**
   * Label to display next to the switch.
   */
  label?: string;
  /**
   * If `true`, the switch will be disabled.
   */
  disabled?: boolean;
  /**
   * Callback fired when the state is changed.
   */
  onChange?: (checked: boolean) => void;
}

export function Switch({ checked, onChange, label, disabled }: SwitchProps) {
  const id = useId();

  return (
    <div className={switchStyles.switchContainer}>
      <BaseSwitch.Root
        className={switchStyles.switchRoot}
        id={id}
        checked={checked}
        onCheckedChange={onChange}
        disabled={disabled}
        data-state={checked ? "checked" : "unchecked"}
      >
        <BaseSwitch.Thumb className={switchStyles.switchThumb} />
      </BaseSwitch.Root>
      {label !== undefined && (
        <label className={switchStyles.switchLabel} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
}
